import { SortType } from '@/models/SortType';
import { SuiviFacture } from '@/models/SuiviFacture';

export interface SuiviFacturesPayeesState {
    facturesPayees: SuiviFacture[];

    page: number;
    nbOfPages: number;
    count: number;

    sort?: {
        sortData: string;
        sortType: SortType;
    };
    scroll: number;
    isLoading: boolean;
    error?: Error;
    success: boolean;
}

export const initialState: SuiviFacturesPayeesState = {
    facturesPayees: [],

    page: 0,
    nbOfPages: 0,
    count: 0,

    scroll: 0,
    isLoading: false,
    success: false,
};

export const state: SuiviFacturesPayeesState = {
    ...initialState,
};
